module.exports = __webpack_public_path__ + "static/img/txtbtn_arrow_off.914ced7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail/txtbtn_arrow_off.png
// module id = l58c
// module chunks = 10